import { Collapse, Stack } from '@mui/material';
import React from 'react';
import { VyLoader } from '../../../../components/new-design/feedback/Loader/VyLoader.tsx';
import { withSuspenseBoundary } from '../../../../components/utility/SuspenseBoundary';
import { CreatePlanLivePreview } from '../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanLivePreview/CreatePlanLivePreview';
import { useCreateCreditNoteContext } from '../create-credit-note-page-contexts/create-credit-note-context/create-credit-note-context';
import { CreateCreditNoteSettings } from './CreateCreditNoteSettings';

const CreateCreditNotePageContentSkeleton: React.FC = () => {
  return (
    <div className="flex h-full w-full overflow-y-hidden bg-[#FAFAFA]">
      <Stack
        spacing={3}
        sx={{
          height: "100%",
          flex: 1,
          padding: 3
        }}>
        <VyLoader variant="text" width="200px" height={40} />
        <VyLoader variant="rectangular" width="100%" height="20%" sx={{ borderRadius: '10px' }} />
        <VyLoader
          variant="rectangular"
          width="100%"
          height="calc(80% - 60px)"
          sx={{ borderRadius: '10px' }}
        />
      </Stack>
    </div>
  );
};

export const CreateCreditNotePageContentBase: React.FC = () => {
  const {
    planPreview: { open, hide },
  } = useCreateCreditNoteContext();

  return (
    <div className="flex h-full w-full overflow-y-hidden bg-[#FAFAFA]">
      <Stack
        sx={{
          height: "100%",
          flex: 1
        }}>
        <CreateCreditNoteSettings />
      </Stack>
      <Collapse
        in={open}
        orientation="horizontal"
        sx={{
          height: '100%',
        }}
      >
        <CreatePlanLivePreview title="Credit Note Preview" onHide={hide} />
      </Collapse>
    </div>
  );
};

const CreateCreditNotePageContentWithSuspense = withSuspenseBoundary(CreateCreditNotePageContentBase, {
  suspenseProps: {
    fallback: <CreateCreditNotePageContentSkeleton />,
  },
});

export const CreateCreditNotePageContent = CreateCreditNotePageContentWithSuspense;
